import CSVPreviewSection from './CSVPreviewSection'

export default function CSVPreviewEmptySection() {}

CSVPreviewEmptySection.prototype = new CSVPreviewSection();
CSVPreviewEmptySection.prototype.init = function ( numOfRows, totalNumOfColumns )
{
    CSVPreviewSection.prototype.init.call( this );
    this.numOfRows = numOfRows;
    this.totalNumOfColumns = totalNumOfColumns;
    return this;
};

CSVPreviewEmptySection.prototype.addRows = function ( tBody )
{
    for( let i = 0; i < this.numOfRows; i++ )
        this.addEmptyRow( tBody );
};

CSVPreviewEmptySection.prototype.addEmptyRow = function ( tBody )
{
    const emptyRow = this.createRow()
    ReportPreviewUtils.addEmptyCells( emptyRow, this.totalNumOfColumns );
    this.addRow( tBody, emptyRow );
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/CSVPreviewEmptySection.js